module.exports = __webpack_public_path__ + "media/2x/graph-73@2x-10b4de50.png";